import { render, staticRenderFns } from "./CommpanyBrandAdd.vue?vue&type=template&id=4c380cb8&"
import script from "./CommpanyBrandAdd.vue?vue&type=script&lang=js&"
export * from "./CommpanyBrandAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports